<template>
  <div class="loginHeader-wrapper">
    <div class="content">
      <img class="logo" src="../../assets/img/pic/pic_logo_rencai1.png" alt="首页" @click="routerGo('index')">
      <el-divider direction="vertical"></el-divider>
      <label>{{ $route.meta.title }}</label>
      <span @click="routerGo('help')">帮助中心</span>
    </div>
  </div>
</template>

<script type="text/ECMAScript-6">
  export default {
    name: 'LoginHeader',
    methods: {
      // 路由跳转
      routerGo(pathName) {
        this.$router.push({ name: pathName });
      }
    }
  };
</script>

<style lang="sass" rel="stylesheet/sass" scoped>
  @import "LoginHeader.sass"
</style>
